import angular from 'angular';
import { ItemReviewCardComponent } from './item-review-card.component';
export default angular
    .module('directives.itemReviewCard', [])
    .component('itemReviewCard', ItemReviewCardComponent)
    .name;
//# sourceMappingURL=index.js.map